/* ME → SKILLS — tap what you can do (her call, 2026-09-25: "a selector …
 * and only that for now"). Replaced the greyed "Soon" row at the top of Me,
 * which read as unfinished right where every coach starts.
 *
 * Shaped like Me → Voice (WritingPanel): the same header and read-out, saving
 * on the press — a chip is a choice, so there is no field to leave. The
 * read-out turns amber when a save fails (rule 1): until supabase/0033 is run
 * that is every save, and "✓ Saved" there would be a lie.
 *
 * Nothing drafts from this yet (her call). When Brill reads it, it is the
 * spec's "facts copy is allowed to use" (docs/voice-layers-spec.md, Me).
 */
import { useEffect, useRef, useState } from "react";
import { Award, Check } from "lucide-react";
import { SKILL_CHOICES, readSkills, toggleSkill } from "../utils/skills";

export function SkillsPanel({ skills: stored, onSave, isMobile }) {
  const [on, setOn] = useState(() => readSkills(stored));
  const [status, setStatus] = useState("idle"); // idle | saving | saved | failed
  /* Loaded after the screen mounted (a slow settings read): take it, unless
     she has already started picking. */
  const touched = useRef(false);
  useEffect(() => { if (!touched.current) setOn(readSkills(stored)); }, [stored]);

  const press = async (id) => {
    touched.current = true;
    const next = toggleSkill(on, id);
    setOn(next);
    setStatus("saving");
    const ok = await onSave(next);
    setStatus(ok ? "saved" : "failed");
  };

  return (
    <div style={{ flex: 1, minHeight: 0, overflowY: "auto", background: "var(--bg-primary)", padding: isMobile ? "16px 16px 100px" : "32px 32px 48px" }}>
      <div style={{ maxWidth: 760, margin: "0 auto", display: "flex", flexDirection: "column", gap: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Award size={18} color="var(--accent)" />
          <div style={{ flex: 1 }}>
            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: "var(--text-primary)" }}>Skills</h2>
            <p role="status" style={{ margin: "2px 0 0", fontSize: 12.5, color: status === "failed" ? "var(--warn-text)" : "var(--text-secondary)" }}>
              {status === "failed" ? "That didn't save. Check your connection and try again."
                : status === "saving" ? "Saving…"
                : status === "saved" ? "✓ Saved"
                : "What you can do. Tap every one that fits."}
            </p>
          </div>
        </div>

        <div role="group" aria-label="Your skills" style={{ display: "flex", flexWrap: "wrap", gap: 8, marginTop: isMobile ? 12 : 20 }}>
          {SKILL_CHOICES.map((s) => {
            const picked = on.includes(s.id);
            return (
              <button key={s.id} type="button" aria-pressed={picked} onClick={() => press(s.id)}
                style={{
                  display: "inline-flex", alignItems: "center", gap: 6,
                  minHeight: isMobile ? 44 : 38, padding: "0 16px", borderRadius: 22,
                  fontSize: 14, fontFamily: "inherit", cursor: "pointer",
                  fontWeight: picked ? 700 : 500,
                  border: `1px solid ${picked ? "var(--accent)" : "var(--border-strong, var(--border))"}`,
                  background: picked ? "var(--accent-quiet)" : "var(--bg-surface)",
                  color: picked ? "var(--accent)" : "var(--text-primary)",
                }}>
                {picked && <Check size={14} />}
                {s.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
